import { useTheme } from '../context/ThemeContext';

/**
 * Alterna claro / oscuro. Boton de icono, sin texto, porque vive en la barra
 * superior junto al selector de periodo y ahi el espacio es de la fecha.
 */
export function ThemeToggle(): JSX.Element {
  const { tema, alternar } = useTheme();
  const aOscuro = tema === 'claro';

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={alternar}
      aria-label={aOscuro ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro'}
      title={aOscuro ? 'Modo oscuro' : 'Modo claro'}
    >
      <span aria-hidden="true">{aOscuro ? <IconoLuna /> : <IconoSol />}</span>
    </button>
  );
}

function IconoLuna(): JSX.Element {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" strokeLinejoin="round" />
    </svg>
  );
}

function IconoSol(): JSX.Element {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <circle cx="12" cy="12" r="4" />
      <path
        d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
